/**
 * Autore: Salvo de Luca
 * Azienda: Dialogicom s.r.l.s.
 * File: src/components/modular-form/custom/ToggleButton.tsx
 * Release: v2.0.0
 * Descrizione: Componente toggle button per form preventivi
 */

import React from 'react';
import type { CustomComponentProps } from '../types';

export const ToggleButton: React.FC<CustomComponentProps> = ({
  field,
  value = false,
  onChange,
  error
}) => {
  const isEnabled = Boolean(value);

  const handleToggle = () => {
    onChange?.(field.id || '', !isEnabled);
  };

  const labelOff = field.labelOff || 'OFF';
  const labelOn = field.labelOn || 'ON';

  return (
    <div className="flex flex-col space-y-2">
      {field.label && (
        <label className="text-sm font-medium text-slate-300">
          {field.label}
          {field.required && <span className="text-red-400 ml-1">*</span>}
        </label>
      )}

      <button
        type="button"
        onClick={handleToggle}
        className={`
          px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200
          ${isEnabled
            ? 'bg-green-600 hover:bg-green-700 text-white border border-green-500'
            : 'bg-red-600 hover:bg-red-700 text-white border border-red-500'
          }
          focus:outline-none focus:ring-2 focus:ring-blue-500/50
        `}
      >
        {isEnabled ? labelOn : labelOff}
      </button>

      {error && (
        <div className="text-red-400 text-xs">{error}</div>
      )}
    </div>
  );
};